import { Box, Center, useDisclosure, VStack } from '@wegroup/design-system';
import React from 'react';
import {
  useCompanyScanDispatch,
  useCompanyScanSelector,
} from '../../../common/src/utils/globalVariables';
import { setSelectedCompany } from '../../store/redux/slices/companyScanSlice';
import CbeLookupNotFoundModal from './CbeLookupNotFoundModal';
import CbeLookupHeader from './CbeLookupHeader';
import { Enterprise } from '../../../../types/ProductFactory';
import CompanyLookup, {
  CompanyLookupCountries,
} from '../../../common/src/components/CompanyLookup';
import useAuth from '../../../app/src/features/authentication/hooks/useAuth';

const CompanyScanCompanyLookup: React.FC = () => {
  const { distribution } = useAuth();

  const {
    isOpen: isOpenNotFoundModal,
    onOpen: onOpenNotFoundModal,
    onClose: onCloseNotFoundModal,
  } = useDisclosure();

  const selectedCompany = useCompanyScanSelector(
    (state) => state.companyScan.selectedCompany,
  );
  const companyScanDispatch = useCompanyScanDispatch();

  const handleChange = (company?: Enterprise) => {
    companyScanDispatch(setSelectedCompany(company));
  };

  return (
    <VStack spacing="6" align="stretch">
      <CbeLookupNotFoundModal
        isOpen={isOpenNotFoundModal}
        onClose={onCloseNotFoundModal}
      />
      <CbeLookupHeader />
      <Center flexDir="column" w="100%">
        <Box maxW="lg" w="100%">
          <CompanyLookup
            value={selectedCompany}
            onChange={handleChange}
            onNotFound={onOpenNotFoundModal}
            showSelected={true}
            defaultCountry={
              (selectedCompany?.address?.country_code ||
                distribution.address.country_code) as CompanyLookupCountries
            }
          />
        </Box>
      </Center>
    </VStack>
  );
};

export default CompanyScanCompanyLookup;
